function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicControlEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.85714,0,0,7.89474,-38.5714,-31.5789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,28C27.31,28 29.98,25.31 29.98,22L30,10C30,6.68 27.32,4 24,4C20.69,4 18,6.68 18,10L18,22C18,25.31 20.69,28 24,28ZM34.6,22C34.6,28 29.53,32.2 24,32.2C18.48,32.2 13.4,28 13.4,22L10,22C10,28.83 15.44,34.47 22,35.44L22,42L26,42L26,35.44C32.56,34.47 38,28.83 38,22L34.6,22Z",
    style: {
      fill: "#39C000",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicControlEnergy);
export default __webpack_public_path__ + "static/media/micControlEnergy.f60ebb05b41360206d979b731eb770c3.svg";
export { ForwardRef as ReactComponent };